module.exports = {
    version     : '7.19',
    build       : "26.10.20.1"        // YY.M.D.#
};

// 26.10.20.1   - Fixes: #51728;
// 26.8.14.2    - Shared View: resolve skin paths via assetsPath;
// 26.8.14.1    - Shared View task view fix;
// 26.8.13.5    - Fixes: font path fix;
// 26.8.13.4    - Fixes: font path fix;
// 26.7.31.2    - Fixes: #35526;
// 26.7.23.2    - Fixes: #33678;
// 26.4.10.1    - 7.8-todo-list-module-session-delta;
// 26.3.25.3    - 7.8-LIST-3;
// 26.3.20.1    - Fixes: #29409;
// 26.2.27.1    - Fixes: #29002;
// 26.2.26.2    - 7.7-BOARD-3;
// 25.10.20.1   - Shared View: AppSharedCalendarProto fix;
// 25.10.17.3   - Fixes: #26771;
// 25.10.17.2   - Fixes: #26773;
// 25.10.17.1   - 7.2-filters-upgrade-v7;
// 25.10.9.1    - Fixes: #24905, #26657;
// 25.10.7.1    - Fixes: #26182;
// 25.7.8.1     - 7.2 pre-release (shared Forms & Requests)
// 25.6.9.1     - Fixes: #25289;
// 25.6.4.1     - Fixes: #25224;
// 25.6.2.1     - Fixes: #25206;
// 25.5.28.1    - Fixes: #25134, #25135;
// 25.5.23.5    - FIX-shared-view;
// 25.5.23.2    - 7.0-v8;
// 25.5.13.1    - Shared View: router requestForm fix;
// 25.3.24.1    - 6.19-VIEW-IN-STRUCTURE-2;
// 25.2.28.2    - Workload and Shared Calendar fixes;
// 25.2.27.1    - Gantt small fixes, shared view board custom view fix;
// 25.2.6.1     - 6.next-Gantt, 6.next-MULTISORT-RC1;
// 25.2.5.2     - Fixes: #22440; 6.16-attachment-custom-field
// 25.2.4.3     - Add api key from google
// 25.2.4.2     - 6.next-CUSTOM-FIELDS-RC1, 6.Next-page-subpages-2
// 25.2.4.1     - 6.Next-clickup-markdown-conversion
// 25.2.3.2     - Page: disabled small fix;
// 25.2.3.1     - 6.Next-page-subpages
// 24.12.18.1   - Fixes: #24581;
// 24.12.10.2   - Fixes: #24494;
// 24.12.4.1    - Fixes: #24446;
// 24.11.28.1   - GD Modules: Table/List customer onClick item fix;
// 24.11.27.1   - Fixes: #24400;
// 24.11.18.1   - Fixes: #24315;
// 24.10.23.3   - Fixes: #24030b;
// 24.10.23.2   - Fixes: #24030;
// 24.10.21.1   - Fixes: #23723;
// 24.10.7.1    - Fixes: #23550;
// 24.10.2.4    - Fixes: #23458;
// 24.7.16.1    - Fixes: #22024, #22046;
// 24.7.11.1    - Fixes: #22024;
// 24.7.9.1     - Fixes: #21764;
// 24.3.22.1    - Fixes: #19916, #19927, #19946, #19961;
// 24.3.1.1     - Fixes: #19350b;
// 24.2.26.2    - GD Modules: Task List TaskListColumnsManager updateListItemsWidth fix;
// 24.2.26.1    - 6.0 release;
// 24.2.20.1    - Fixes: #19393;
// 24.2.6.1     - Fixes: #19160;
// 23.11.16.4   - Fixes: #18070, #18072, #18090;
// 23.11.15.1   - 5.17 release;
// 23.9.7.1     - Fixes: #17137;
// 23.8.30.1    - Fixes: #17157;
// 23.8.11.1    - Fixes: #16835;
// 23.7.31.2    - Data storage requests fix;
// 23.7.31.1    - Fixes: #16723, #16724, #16726;
// 23.6.12.1    - #16256
// 23.6.9.2     - 5.10-dashboard-shared-view (#16195) - widgets fixes
// 23.6.9.1     - 5.10-dashboard-shared-view (#16195)
// 23.6.8.1     - Fixes: #16240;
// 22.4.19.1    - Fix shared calendar
// 4.8          - Release
// 4.3.1        - Official release
// 4.3          - First releases
// 0.2          - Vic + shared view
// 0.1          - Andrew